<template lang="pug">
v-container
  div.text-lg.font-medium.basic700--text {{ $t('sharing_embed') }}
  div.text-sm.font-normal.basic600--text {{ $t('sharing_embed_desc') }}

  div.text-md.font-medium.basic700--text.mt-6 {{ $t('how_to_add_campaign') }}

  v-radio-group(v-model="embedSelection")
    v-radio(value="floating" color="basic700" )
      template(v-slot:label)
        div.text-md.font-normal.basic700--text {{ $t('as_a_floating_button') }}
    v-radio(value="iframe" color="basic700")
      template(v-slot:label)
        div.text-md.font-normal.basic700--text {{ $t('as_a_page') }}

  div.text-md.font-medium.basic700--text.mt-4 {{ $t('choose_link') }}

  v-row(no-gutters)
    v-col(cols="12" sm="7")
      v-radio-group(v-model="layoutSelection")
        div.d-flex
          v-radio.mt-n2(value="page" color="basic700" )
          div(@click="layoutSelection = 'page'")
            div.text-md.font-normal.basic700--text {{ $t('donation_page') }}
            div.text-sm.font-normal.neutral500--text {{ getPageURL() }}
          v-spacer
          v-btn.button-sm(color="primary" outlined @click="openLink('page')") {{ $t('example') }}
        div.d-flex.mt-3
          v-radio.mt-n2(value="form" color="basic700" )
          div(@click="layoutSelection = 'form'")
            div.text-md.font-normal.basic700--text {{ $t('donation_form') }}
            div.text-sm.font-normal.neutral500--text {{ getFormURL() }}
          v-spacer
          v-btn.button-sm(color="primary" outlined @click="openLink('form')") {{ $t('example') }}
  
  v-btn.round-lg.heading-6.px-8.mt-8(color="info500" depressed height="48" :dark="!disabledGetCode" :disabled="disabledGetCode" :loading="isLoading" @click="clickGetCode") {{ $t('get_code') }}

  .modals
    embed-dialog(v-if="openEmbedDialog" :open.sync="openEmbedDialog" :copyCode="copyCode" :showCode="showCode")   
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EmbedDialog from '@/components/donation/dialogs/EmbedDialog.vue'

export default {
  name: 'SharingEmbed',
  components: { EmbedDialog },
  data () {
    return {
      isLoading: false,
      openEmbedDialog: false,
      embedSelection: null,
      layoutSelection: null,
      copyCode: '',
      showCode: '',
      rules: {
        not_empty: [v => v.trim().length || 'This field is required'],
        not_empty_array: [v => !!(v && v.length) || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      campaign: 'donation/getCampaign'
    }),
    disabledGetCode () {
      if (this.layoutSelection && this.embedSelection) {
        return false
      }
      return true
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    openLink (layout) {
      if (layout === 'page') {
        window.open(this.getPageURL(), '_blank')
      } else if (layout === 'form') {
        window.open(this.getFormURL(), '_blank')
      }
    },
    getPageURL () {
      return `https://${this.company.slug}.yezza.co/donation/${this.campaign.form.slug}`
    },
    getFormURL () {
      return `https://${this.company.slug}.yezza.co/donation/${this.campaign.form.slug}/form`
    },
    getFloatingPageURL () {
      return `https://${this.company.slug}.yezza.co/donation/${this.campaign.form.slug}/embed-page`
    },
    getFloatingFormURL () {
      return `https://${this.company.slug}.yezza.co/donation/${this.campaign.form.slug}/embed-form`
    },
    clickGetCode () {
      this.isLoading = true
      if (this.embedSelection === 'iframe') {
        if (this.layoutSelection === 'page') {
          this.$axios.get(`https://${this.company.slug}.${process.env.VUE_APP_BASE_DOMAIN}/embedform/iframe.txt`)
            .then((resp) => {
              this.copyCode = resp.data.toString().replace('src=""', `src="${this.getPageURL()}"`)
              this.showCode = this.copyCode
              this.openEmbedDialog = true
              this.isLoading = false
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
              this.isLoading = false
            })
        } else if (this.layoutSelection === 'form') {
          this.$axios.get(`https://${this.company.slug}.${process.env.VUE_APP_BASE_DOMAIN}/embedform/iframe.txt`)
            .then((resp) => {
              this.copyCode = resp.data.toString().replace('src=""', `src="${this.getFormURL()}"`)
              this.showCode = this.copyCode
              this.openEmbedDialog = true
              this.isLoading = false
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
              this.isLoading = false
            })
        }
      } else if (this.embedSelection === 'floating') {
        if (this.layoutSelection === 'page') {
          this.$axios.get(`https://${this.company.slug}.${process.env.VUE_APP_BASE_DOMAIN}/embedform/floating.txt`)
            .then((resp) => {
              this.showCode = resp.data.toString().replace('src=""', `src="${this.getFloatingPageURL()}"`)
              this.$axios.get(`https://${this.company.slug}.${process.env.VUE_APP_BASE_DOMAIN}/embedform/floating-copy.txt`)
                .then((resp2) => {
                  this.copyCode = resp2.data.toString().replace('src=""', `src="${this.getFloatingPageURL()}"`)
                  this.openEmbedDialog = true
                  this.isLoading = false
                })
                .catch(() => {
                  this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
                  this.isLoading = false
                })
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
              this.isLoading = false
            })
        } else if (this.layoutSelection === 'form') {
          this.$axios.get(`https://${this.company.slug}.${process.env.VUE_APP_BASE_DOMAIN}/embedform/floating.txt`)
            .then((resp) => {
              this.showCode = resp.data.toString().replace('src=""', `src="${this.getFloatingFormURL()}"`)
              this.$axios.get(`https://${this.company.slug}.${process.env.VUE_APP_BASE_DOMAIN}/embedform/floating-copy.txt`)
                .then((resp2) => {
                  this.copyCode = resp2.data.toString().replace('src=""', `src="${this.getFloatingFormURL()}"`)
                  this.openEmbedDialog = true
                  this.isLoading = false
                })
                .catch(() => {
                  this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
                  this.isLoading = false
                })
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
              this.isLoading = false
            })
        }
      }
    }
  }

}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>